import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import { AjaxContext, AppContext, UserContext } from 'commons-ui';
import { ACTION } from 'constant';

import { COUPON_TNC_FALLBACK_TXT, COUPON_FIELD_MAPPING } from './constants';

const useService = () => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const { permissionsConfig } = useContext(UserContext);

	const getCouponTnc = useCallback(async ({ couponCode, couponId }: { couponCode: string; couponId?: number }) => {
		let payload;
		if (!_isEmpty(couponCode)) {
			payload = { code: couponCode };
		} else {
			payload = { cid: couponId };
		}
		const permission = _find(permissionsConfig, { actionName: ACTION.getCouponTnC });
		const result = await postData({
			endpoint: '/dashboard/getCouponTnC/reward-coupons-getCouponTnC',
			queryParams: {
				appName
			},
			body: payload,
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const couponData = _get(result, ['data', 'data']);
		return {
			couponId: _get(couponData, COUPON_FIELD_MAPPING.COUPON_ID),
			couponCode: _get(couponData, COUPON_FIELD_MAPPING.COUPON_CODE),
			tncHTML: _get(couponData, 'info', COUPON_TNC_FALLBACK_TXT)
		};
	}, []);

	return {
		getCouponTnc
	};
};

export default useService;
